<template>
  <div class="module-properties">
    <div class="form-group">
      <label>Campo para Filtro</label>
      <input type="text" v-model="config.field" placeholder="Nome do campo">
    </div>
    
    <div class="form-group">
      <label>Operador</label>
      <select v-model="config.operator">
        <option value="equals">Igual a</option>
        <option value="notEquals">Diferente de</option>
        <option value="greaterThan">Maior que</option>
        <option value="lessThan">Menor que</option>
        <option value="contains">Contém</option>
        <option value="startsWith">Começa com</option>
        <option value="endsWith">Termina com</option>
        <option value="isNull">É nulo</option>
        <option value="isNotNull">Não é nulo</option>
      </select>
    </div>
    
    <div class="form-group" v-if="!['isNull', 'isNotNull'].includes(config.operator)">
      <label>Valor</label>
      <input type="text" v-model="config.value" placeholder="Valor para comparação">
    </div>
    
    <div class="form-group">
      <label>Ação</label>
      <select v-model="config.action">
        <option value="keep">Manter registros que atendem ao filtro</option>
        <option value="remove">Remover registros que atendem ao filtro</option>
      </select>
    </div>
    
    <div class="form-group">
      <label>Aplicar a</label>
      <select v-model="config.applyTo">
        <option value="all">Todos os registros</option>
        <option value="sample">Amostra de registros</option>
      </select>
    </div>
    
    <div class="form-group" v-if="config.applyTo === 'sample'">
      <label>Tamanho da Amostra (%)</label>
      <input type="number" v-model="config.sampleSize" min="1" max="100" placeholder="Ex: 10">
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterModuleProperties',
  props: {
    module: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      config: {
        field: '',
        operator: 'equals',
        value: '',
        action: 'keep',
        applyTo: 'all',
        sampleSize: 10,
        ...this.module.config
      }
    };
  },
  watch: {
    config: {
      handler(newConfig) {
        this.$emit('update:config', newConfig);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.module-properties {
  padding: 10px;
}
.form-group {
  margin-bottom: 15px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}
select, input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
